module.exports = __webpack_public_path__ + "img/kanban-icon.3ab0abe5.svg";